export default "__VITE_ASSET__GEwN73uX__"